import { useId } from 'react';
import cn from 'classnames';
import { Checkbox } from '@heroui/react';
import styles from './CustomCheckboxField.module.scss';

interface CustomCheckboxFieldProps {
  label: string;
  title: string;
  description?: string;
  isSelected: boolean;
  onValueChange: (isSelected: boolean) => void;
}

/** A checkbox laid out as a form field: label on top, the option with a hint in a frame. */
export const CustomCheckboxField = ({
  label,
  title,
  description,
  isSelected,
  onValueChange,
}: CustomCheckboxFieldProps) => {
  const descriptionId = useId();

  return (
    <div className="flex flex-col gap-1.5">
      <span className={styles.label}>{label}</span>
      <Checkbox
        isSelected={isSelected}
        onValueChange={onValueChange}
        aria-describedby={description ? descriptionId : undefined}
        classNames={{
          base: cn(styles.frame, 'm-0 max-w-none', { [styles.selected]: isSelected }),
          wrapper: 'shrink-0',
          icon: 'text-white',
          label: 'flex flex-col gap-0.5',
        }}
      >
        <span className="text-sm font-medium !text-black">{title}</span>
        {description && (
          // `!` keeps the color when a modal paints everything inside [data-selected] white
          <span id={descriptionId} className="text-xs !text-grey-secondary">
            {description}
          </span>
        )}
      </Checkbox>
    </div>
  );
};
